import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, MessageCircle, MapPin, FileText } from "lucide-react";
import { Button } from "./ui/button";
import { useLang } from "../context/LanguageContext";
import { WHATSAPP_URL } from "../lib/i18n";

export function FinalCTA() {
  const { t, isRTL } = useLang();
  const Arrow = isRTL ? ArrowLeft : ArrowRight;

  return (
    <section className="relative py-24 overflow-hidden bg-[#0891b2] text-white" data-testid="final-cta">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.15] pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(135deg, rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(45deg, rgba(255,255,255,0.05) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
          }}
        />
      </div>
      <div
        className="absolute -top-32 -end-32 w-96 h-96 rounded-full bg-[#ef4444]/20 blur-3xl pointer-events-none"
      />
      <div
        className="absolute -bottom-40 -start-32 w-[500px] h-[500px] rounded-full bg-blue-400/20 blur-3xl pointer-events-none"
      />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-block text-[10px] tracking-[0.3em] text-red-300 font-semibold mb-5 uppercase">
          {t.finalBigCta.eyebrow}
        </div>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mb-6 leading-[1.1]">
          {t.finalBigCta.title}
        </h2>
        <p className="text-cyan-100 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          {t.finalBigCta.subtitle}
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/quote">
            <Button
              data-testid="final-cta-quote"
              className="bg-[#ef4444] hover:bg-[#dc2626] text-white h-14 px-8 text-sm font-semibold shadow-xl hover:shadow-2xl hover:-translate-y-0.5 transition-all"
            >
              <FileText className="w-4 h-4 me-2" /> {t.finalBigCta.btn1} <Arrow className="w-4 h-4 ms-2" />
            </Button>
          </Link>
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer">
            <Button
              data-testid="final-cta-whatsapp"
              className="bg-green-600 hover:bg-green-700 text-white h-14 px-8 text-sm font-semibold shadow-xl"
            >
              <MessageCircle className="w-4 h-4 me-2" /> {t.finalBigCta.btn2}
            </Button>
          </a>
          <Link to="/branches">
            <Button
              variant="outline"
              data-testid="final-cta-branches"
              className="bg-transparent border-white/40 text-white hover:bg-white hover:text-[#0891b2] h-14 px-8 text-sm font-semibold"
            >
              <MapPin className="w-4 h-4 me-2" /> {t.finalBigCta.btn3}
            </Button>
          </Link>
        </div>
        <div className="mt-10 flex flex-wrap justify-center items-center gap-6 text-cyan-200/80 text-xs tracking-widest uppercase">
          <span dir="ltr">+971 4-288-2777</span>
          <span className="hidden sm:inline">·</span>
          <span dir="ltr">admin@mariotkitchen.com</span>
        </div>
      </div>
    </section>
  );
}
